/** `0 -> "01"` — the ordinal notation used throughout the layout. */
export function ordinal(index: number): string {
  return String(index + 1).padStart(2, '0');
}
